var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E4E4E4",
    cx: 58.614,
    cy: 58.614,
    r: 58.614
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.399 90.46H24.687a7.016 7.016 0 0 1-6.131-3.533c-1.256-2.167-1.275-4.724-.053-7.014l33.856-63.42c1.213-2.27 3.524-3.626 6.184-3.626s4.972 1.355 6.184 3.626l33.856 63.42c1.223 2.29 1.203 4.847-.053 7.014A7.016 7.016 0 0 1 92.4 90.46z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.583 79.913-33.856-63.42c-1.212-2.27-3.524-3.626-6.184-3.626V90.46h33.856c2.557 0 4.85-1.321 6.131-3.533 1.256-2.167 1.275-4.724.053-7.014z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.543 80.063c-3.529 0-6.4-2.871-6.4-6.4 0-3.53 2.871-6.4 6.4-6.4 3.53 0 6.4 2.87 6.4 6.4 0 3.529-2.87 6.4-6.4 6.4zM58.543 60.863c-3.529 0-6.4-2.871-6.4-6.4v-13.84c0-3.53 2.871-6.4 6.4-6.4 3.53 0 6.4 2.87 6.4 6.4v13.84c0 3.529-2.87 6.4-6.4 6.4z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.543 34.223v26.64c3.53 0 6.4-2.871 6.4-6.4v-13.84c0-3.529-2.87-6.4-6.4-6.4zM58.543 67.263v12.8c3.53 0 6.4-2.871 6.4-6.4 0-3.53-2.87-6.4-6.4-6.4z",
    fill: "#D2D2D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.8bc8c7df5f728d52695833f1a0f48aa6.svg";
export { ForwardRef as ReactComponent };